<template>
<v-container fluid>
  <v-row>
    <v-col cols="12">
      <QuickBreaks v-if="therapist_id > 0" :therapistID="therapist_id"></QuickBreaks>
    </v-col>
  </v-row>
</v-container>
</template>

<script>
import QuickBreaks from "@/components/therapists/QuickBreaks";
import {therapistsService} from "@/services";

export default {
  name: "QuickBreaksStandAlone",
  components: {QuickBreaks},
  data() {
    return {
      therapist_id: 0
    }
  },
  methods: {
    getAllTherapists() {
      therapistsService
          .getAll({ query: '', page: 1, limit: 9999, IsActive: true, GetSchedules: true })
          .then(response => {
            if (
                response.data != null &&
                response.data.result != null &&
                response.data.result.items != null
            ) {
              let fullTherapistList = response.data.result.items
              let user = JSON.parse(localStorage.getItem('user'));

              fullTherapistList.forEach(itm => {
                if(itm.userId == user.userId)
                {
                  this.therapist_id = itm.therapistID
                }
              });
            } else {
              throw "error pobierania terapeutów";
            }
          })
          .catch(e => {
            this.isLoadingTherapists = false;
            this.error("Nie można pobrać listy terapeutów.");
          });
    },
  },
  mounted() {
    this.getAllTherapists()
  }
}
</script>

<style scoped>

</style>